import { useMemo } from "react";
import dayjs from "dayjs";

export const useFormConfig = (data) => {
  const initialValues = useMemo(
    () => ({
      start_date: data?.start_date || dayjs(), // Дата начала
      end_date: data?.end_date || dayjs(), // Дата окончания
      limits: data?.limits || "forever", // Пределы повторений
      repeat_count: data?.repeat_count || 1, // Кол-во повторений
      frequency: data?.frequency || "daily", // Частота
      only_workdays: data?.only_workdays || false, // По будням

      // По дням
      n_count: data?.n_count || 1,

      // По неделям
      m_count: data?.m_count || 1,
      weeks_days: data?.weeks_days || [],

      // По месяцам
      monthly_frequency_option:
        data?.monthly_frequency_option || "day_of_month",

      monthly_frequency_val_1: data?.monthly_frequency_val_1 || 1,
      monthly_frequency_val_2: data?.monthly_frequency_val_2 || 1,
      monthly_frequency_val_3: data?.monthly_frequency_val_3 || "monday",
      monthly_frequency_val_4: data?.monthly_frequency_val_4 || 1,
      monthly_frequency_val_5: data?.monthly_frequency_val_5 || 1,

      // По годам
      frequency_by_year_val_1: data?.frequency_by_year_val_1 || 1,
      frequency_by_year_val_2: data?.frequency_by_year_val_2 || 1,
      frequency_by_year_val_3: data?.frequency_by_year_val_3 || 1,

      // Следующая задача появится
      start_next_task: data?.start_next_task || null,

      f_count: data?.f_count ?? null,
      g_count: data?.g_count ?? null,
    }),
    [data]
  );

  return {
    initialValues,
  };
};
